import React, { useEffect } from 'react'
import Spinner from './Spinner/Spinner';
import psl from 'psl';

export const OAuthCallback = () => {
  const mustRedirect = (url: string): boolean => {
    const hostname = new URL(url).hostname
    const { domain } = psl.parse(hostname.replace(/_/g, ''));
    return (domain === 'gupy.io' || domain === 'niduu.com')
  }

  useEffect(() => {
    const params = new URL(document.location.href).searchParams
    const redirect_uri = params.get('redirect_uri')

    if(mustRedirect(redirect_uri as string)) {
      window.location.replace(redirect_uri as string)
    }
  }, [])

  return (
    <Spinner size={60}/>
  )
}